export enum CategoryType {
    CHANNEL = "channel",
    GALLERY = "gallery",
}

export enum GenieContextType {
    ENTRY = "entry",
    CATEGORY = "category",
    ANCESTOR = "ancestor-category",
}

export interface CategoryData {
    id: number;
    name: string;
    type: CategoryType;
    isAncestorType?: boolean;
}

export interface EntryData {
    id: string;
    title?: string;
    imageUrl?: string;
}

export interface BaseSettingsParams {
    ks: string;
    partnerId: number;
    agentMode: boolean;
    categoryData?: CategoryData;
    categoryUrl: string;
    entryData?: EntryData;
    mode?: GenieMode;
    sourcePageUrl?: string;
}

export interface GenieContextParams {
    entryData?: EntryData;
    categoryData?: CategoryData;
    sourcePageUrl?: string;
}

export interface BaseGenieProps {
    ks: string;
    categoryData?: CategoryData;
    agentMode?: boolean;
    entryData?: EntryData;
    visualType?: string;
    mode?: GenieMode;
}

export type GetSourceUrlType = {
    /** type of context - entry, category, ancestor-category */
    type?: GenieContextType;
    /** entry id, in case of entry context */
    entryId?: string;
    /** start time of entry, in case of entry context */
    startTime?: number;
    /** category id, in case of category context */
    categoryId?: string;
};

export type BaseGenieSettings = {
    shareUrl: {
        queryParam: "mid";
        createUrl: (params: { messageId: string }) => string;
    };
    ks: string;
    partnerId: string;
    agentMode: boolean;
    getSourceUrl: any;
};

export type GenieMode = "chat" | "everywhere";
